<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>
<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row">
                <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-2"> -->
                <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-2">
                  <div class="btn-group enrollment-list-btn-info" role="group">
                    <div *ngFor="let status of learner_status" >
                      <button 
                      id="status-btns" type="button" class="btn"
                      [ngClass]="{'btn-primary': status?.name ==='Pending' || status?.name ==='Classroom' || status?.name ==='Live' || status?.name ==='Completed' ,'btn-outline-primary':activeTab !==status?.name && activeTab !==status?._id }"
                      (click)="activeLearnerTab(status?._id)">{{status?.name}}</button>
                    </div>
                    
                    <!-- <button type="button" class="btn cursor-pointer"
                      [ngClass]="{'btn-primary':activeTab=='pending','btn-outline-primary':activeTab!='pending'}"
                      (click)="activeEnrollmentTab(activeTab=='pending'?'':'pending')">Pending</button>
                    <button type="button" class="btn cursor-pointer"
                      [ngClass]="{'btn-primary':activeTab=='enrolled','btn-outline-primary':activeTab!='enrolled'}"
                      (click)="activeEnrollmentTab(activeTab=='enrolled'?'':'enrolled')">Enrolled</button>
                    <button type="button" class="btn cursor-pointer"
                      [ngClass]="{'btn-primary':activeTab=='completed','btn-outline-primary':activeTab!='completed'}"
                      (click)="activeEnrollmentTab(activeTab=='completed'?'':'completed')">Completed</button> -->
                    <!-- <button type="button" class="btn" [ngClass]="{'btn-primary':activeTab=='due','btn-outline-primary':activeTab!='due'}"  (click)="activeEnrollmentTab(activeTab=='due'?'':'due')"> Due fees</button>
                    <button type="button" class="btn" [ngClass]="{'btn-primary':activeTab=='pendingFees','btn-outline-primary':activeTab!='pendingFees'}"  (click)="activeEnrollmentTab(activeTab=='pendingFees'?'':'pendingFees')">Pending fees</button> -->
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-2 mb-2">
                  <!-- <button  class="btn btn-primary" (click)="dueFeesModal()">Due Fees</button> -->
                </div>
              </div>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
            rowHeight="auto" [rows]="learners" [columns]="columns" [scrollbarH]="true">
            <ngx-datatable-column *ngFor="let col of columns" [name]="col.name" [prop]="col.prop">
              <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                <ng-container *ngIf="col.prop === 'createdAt'; else defaultCell">
                  {{ row[col.prop] | date:'short' }}
                </ng-container>
                <ng-template #defaultCell>
                <span *ngIf="row.enrollment && col.prop === 'enrollment.courseName'">{{ row.enrollment.courseName }}</span>
                <span *ngIf="row.enrollment && col.prop === 'enrollment.courseLink'">{{ row.enrollment.courseLink }}</span>
                <span *ngIf="row.enrollment && col.prop === 'enrollment.assignedThrough'">{{ row.enrollment.assignedThrough }}</span>
                <span *ngIf="row.enrollment && col.prop === 'enrollment.courseValidity'">{{ row.enrollment.courseValidity }}</span>
                  <span [hidden]="col.prop === 'status'">
                    {{ row[col.prop] }}
                  </span>
                  <span *ngIf="col.prop === 'status'">
                    <span class="badge" [ngClass]="{
                      'badge-success': row.status === 'completed',
                      'badge-info': row.status === 'classroom',
                      'badge-warning': row.status === 'pending',
                      'badge-primary': row.status === 'live'
                    }">{{ row.status }}
                    </span>
                  </span>
                </ng-template>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
      
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>

</section>